import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './Login.css';

const RECAPTCHA_SITE_KEY = 'YOUR_RECAPTCHA_SITE_KEY';

const Login = ({ setUser }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (username && password) {
      try {
        const response = await axios.post('https://auth.elitetravelexpertsbyjta.co.uk/login', {
          username,
          password
        });
        const userData = response.data;
        if (response.status === 200 && (userData.user.team === 'ETE' || userData.user.team === 'ATO')) {
          setUser(username);
          navigate('/landing');
          // navigate('/layout');
        } else if (response.status === 200 && userData.user.team !== 'ETE' && userData.user.team !== 'ATO') {
          setError('You are not authorized to access this application.');
        }
      } catch (err) {
        if (err.response && err.response.status === 401) {
          setError('Invalid username or password');
        } else {
          setError('An error occurred. Please try again later.');
        }
      }
    } else {
      setError('Please fill in all fields ');
    }
  };

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  return (
    <div className="login-container">
      {/* <div className="background-left"></div> */}
      <div className="login-form-container">
        <div className="login-form">
          <h1 style={{textAlign:'center'}}>Welcome</h1>
          <form onSubmit={handleLogin}>
            <div>
              <label>Username:</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="input-wrapper">
              <label>Password:</label>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <div
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </div>
            {/* <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              onChange={handleRecaptchaChange}
            /> */}
            <button type="submit">Login</button>
          </form>
          {error && <p className="error-message">{error}</p>}
        </div>
      </div>
    </div>
  );
};

export default Login;
